<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19 0C8.50567 0 0 8.50567 0 19C0 29.4943 8.50567 38 19 38C29.4943 38 38 29.4943 38 19C38 8.50567 29.4943 0 19 0ZM24.2799 14.8876C24.2799 17.7988 21.9197 20.1653 19.0021 20.1653C16.0846 20.1653 13.7243 17.7988 13.7243 14.8876C13.7243 11.97 16.0846 9.60978 19.0021 9.60978C21.9197 9.60978 24.2799 11.97 24.2799 14.8876ZM19.0021 22.0041C23.845 22.0041 27.8857 25.2848 29.127 29.7329C26.4797 32.2346 22.9224 33.7778 19 33.7778C15.0818 33.7778 11.5246 32.2346 8.87722 29.7371C10.1186 25.2848 14.1571 22.0041 19.0021 22.0041Z"
      :fill="webDesign.design.main_color"
    />
  </svg>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
       width: {
          type: Number,
          default: 38
      },
      height: {
          type: Number,
          default: 38
      },
  },  
  computed: {
    ...mapState("estore", ["webDesign"]),
  },
};
</script>